import React, {useState} from 'react';
import {connect} from 'react-redux';
import {logConversionsActions} from '../../store/actions/logConversionsAction';
import LogConversionDialog from './LogConversionDialog';

function LogConversionsOverrideConversion({history, location, match, rerender}) {
    const [open, setOpen] = useState(true);
    const handleClose = () => {
        setOpen(false);
        history.push({pathname: '/log/conversions', state: {from: location}});
    };
    return <LogConversionDialog open={open} mode="override" clickId={match?.params?.id} onClose={handleClose} onSaved={() => {rerender(); handleClose();}}/>;
}

export default connect(null, {rerender: logConversionsActions.rerender})(LogConversionsOverrideConversion);
